/**
 * Ajax filtering for the Blog landing page
 */
(function (window, document, $, undefined) {
	'use strict';

	window.blogFilter = {

		/**
		 * Initialize script behavior.
		 *
		 * @since 1.0.0
		 */
		init: function () {
			blogFilter.initVars();
			blogFilter.getQueryVars();
			blogFilter.pageInit();
			blogFilter.bind();
			blogFilter.submit();
			blogFilter.tagToggle();
			blogFilter.filterReset();
		},

		/**
		 * Setting and initializing all variables.
		 *
		 * @since 1.0.0
		 */
		initVars: function () {
			blogFilter.$base_url   = $( "#base_url" ).val();
			blogFilter.$xhrQueue   = [];
			blogFilter.$form_reset = false;
			blogFilter.$resetStat  = false;
		},

		/**
		 * Get all of the select values for the query string
		 *
		 * @since 1.0.0
		 */
		getQueryVars: function () {
			// (re)set the object
			blogFilter.$query_vars = {};

			// Get non-checkbox values
			$( '.page-template-blog-landing-us .filter-select' ).each(
				function () {
					// If a form field ins't empty add it to the array
					if ($( this ).val() !== '') {
						blogFilter.$query_vars[$( this ).data( 'arg-type' )] = $( this ).val();
					}
				}
			);

			// Special handling for tags checkboxes
			// Grab all the values and comma separate them
			blogFilter.$tagValues = $( '.page-template-blog-landing-us .tag-checkbox:checked' ).map(
				function(){
					return $( this ).val();
				}
			).get().join( "," );

			if (blogFilter.$tagValues != '') {
				blogFilter.$query_vars['tags'] = blogFilter.$tagValues;
			}
		},

		/**
		 * Build the URL we need to call
		 *
		 * @since 1.0.0
		 */
		buildTheURL: function () {
			// Build the query string
			blogFilter.getQueryVars();

			// If empty use the base URL
			if ($.isEmptyObject( blogFilter.$query_vars )) {
				return blogFilter.$base_url;
			}

			var query_vars = '?';
			Object.keys( blogFilter.$query_vars ).forEach(
				function (key) {
					var value = blogFilter.$query_vars[key];
					query_vars += key + '=' + value.replace(/\s/g, "+") + '&';
				}
			);
			return blogFilter.$base_url + query_vars.replace( /&\s*$/, "" );
		},

		/**
		 * Put everything together and make the call
		 *
		 * @since 1.0.0
		 */
		makeTheCall: function ( url, reset_stat ) {
			blogFilter.$resetStat = reset_stat || false;
			// Kill all active xhr requests before starting a new one.
			var i = 0;
			while (blogFilter.xhrAbort() && i < blogFilter.$xhrQueue.length) {
				if( blogFilter.$xhrQueue[i] ){
					blogFilter.$xhrQueue[i].abort();
				}
				i++;
			}

			// Make the call
			blogFilter.filterAjaxCall( url, blogFilter.$resetStat );
		},

		/**
		 * Call the formatted URL
		 *
		 * @since 1.0.0
		 */
		filterAjaxCall: function ( url, reset_stat ) {
			blogFilter.$resetStat = reset_stat || false;
			// Show the 'loading' overlay
			$( '.page-template-blog-landing-us .loading-overlay' ).show();

			// Make the call
			$( ".page-template-blog-landing-us #ajax-archive" ).load(
				url + ' #ajax-archive', function(response, status, xhr){
					if (status == "success") {
						// Hide the overlay on success
						$( '.loading-overlay' ).hide();
						// Push the browser history state
						var stateObj   = {state: "ready"};
						var page_title = $( document ).find( "title" ).text();
						history.pushState( stateObj, page_title, url );
					} else {
						if( typeof xhr.responseText != 'undefined' ){
							var err = xhr.responseText;
						}
					}
					
					// Check if form was reset
					if( blogFilter.$resetStat == false ) {
						gtmHelper.formSubmitEvent( blogFilter.$form_name, status, err );
					}		
				}
			);
		},

		/**
		 * Abort all active xhr requests before making a new one.
		 *
		 * @since 1.0.0
		 */
		xhrAbort: function () {
			$( document ).ajaxSend(
				function(event,jqxhr,settings){
					blogFilter.$xhrQueue.push( jqxhr ); //alert( settings.url );
				}
			);
			$( document ).ajaxComplete(
				function(event,jqxhr,settings){
					var i;
					if ((i = $.inArray( jqxhr,blogFilter.$xhrQueue )) > -1) {
						blogFilter.$xhrQueue.splice( i,1 ); //alert( "C:" + settings.url );
					}
				}
			);
			return blogFilter.$xhrQueue.length;
		},

		/**
		 * Toggle the tag selector div
		 *
		 * @since 1.0.0
		 */
		tagToggle: function() {
			$( "#blog-tag-toggle" ).click(
				function(e) {
					e.preventDefault();
					$( ".page-template-blog-landing-us #filter-tags" ).toggle(
						500, function() {
						}
					);
				}
			);
		},

		/**
		 * Reset the filter
		 *
		 * @since 1.0.0
		 */
		filterReset: function() {
			$( "#blog-filter #filter-reset" ).click(
				function(e) {
					e.preventDefault();

					if( encodeURI(window.location.href) !== blogFilter.$base_url ) {
						$( '#blog-filter .jh-checkbox' ).removeClass( 'jh-checkbox--checked' );

						// Reset the filter form to empty
						$( '#blog-filter' ).trigger( "reset" );

						// Make the call
						blogFilter.makeTheCall( blogFilter.$base_url, true );
					}
				}
			);
		},

		/**
		 * Bind all event listeners.
		 *
		 * @since 1.0.0
		 */
		bind: function () {

			$( "#blog-filter" ).bind(
				// Debounce for 1 second before triggering
				"keyup change", jh_custom.debounce( 
					function() {
						blogFilter.makeTheCall( blogFilter.buildTheURL() ), 
						1000
					}
				)
			);
		},
	
		/**
		 * Submit Button.
		 *
		 * @since 1.0.0
		 */
		submit: function () {
			$("#blog-filter").submit(
				function (e) {
					e.preventDefault();
					blogFilter.makeTheCall( blogFilter.buildTheURL() );
				});

		},

		/**
		 *  Adjust the filter on initial page load if coming from another link and not ajax
		 *
		 * @since 1.0.0
		 */
		pageInit: function () {

			// If there are tags in the URL expand the tags select div
			if (blogFilter.$tagValues != '') {
				$( ".page-template-blog-landing-us #filter-tags" ).toggle(
					500, function() {
					}
				);
			}

			// If there are any query vars at all, scroll down to the results
			if ($.isEmptyObject( blogFilter.$query_vars )) {
				// No empty actions at this time
			} else {
				// Wait until doc ready to scroll to avoid jitter
				$( document ).ready(
					function() {
						$.scrollTo( '.page-template-blog-landing-us #ajax-archive', 500, {offset: -75} );
					}
				);
			}
		},

	};

	blogFilter.init();

})( window, document, jQuery );
